import Vue from 'vue'

export default {
  serialize: function (obj, prefix) {
    var str = []
    var k = ''
    var v = null
    for (var p in obj) {
      if (obj.hasOwnProperty(p)) {
        k = prefix ? prefix + '[' + p + ']' : p
        v = obj[p]
        str.push(encodeURIComponent(k) + '=' + encodeURIComponent(v))
      }
    }
    return str.join('&')
  },
  paginate: function (url, meta) {
    let important = {
      page: meta.current_page,
      limit: meta.per_page,
      sort: meta.sort,
      direction: meta.direction
    }
    if (meta.filter) {
      for (var p in meta.filter) {
        if (meta.filter.hasOwnProperty(p)) {
          important[p] = meta.filter[p]
        }
      }
    }

    const path = this.serialize(important)
    return Vue.http.get(url + '?' + path)
  },
  errorMessages: function (keys) {
    const base = {
      required: 'To pole jest wymagane',
      min: 'Zbyt mała liczba znaków',
      max: 'Zbyt duża liczba znaków',
      numeric: 'Wpisz numer',
      email: 'Wpisz poprawny e-mail'
    }
    let ret = {}
    for (var i = 0; i < keys.length; i++) {
      ret[keys[i]] = base[keys[i]]
    }

    return ret
  },
  isFunction: function (functionToCheck) {
    var getType = {}
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]'
  },
  multiselectToIds (val, key = 'id') {
    return val.map((v) => v[key])
  },
  keysForSelect () {
    return {
      label: 'name',
      value: 'id'
    }
  },
  convertNulls (keys, item) {
    for (var key in item) {
      if (item.hasOwnProperty(key)) {
        // is null
        if (item[key] === null && keys.indexOf(key) !== -1) {
          item[key] = ''
        }
      }
    }
    return item
  }
}



// WEBPACK FOOTER //
// ./src/services/Utils.js